import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { faFileInvoiceDollar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, useTheme } from '@mui/material';
import { SolidButton, StyledHeader, StyledParagraph } from './styles';

export const PayPolicy = ({ policy }: any) => {
  const theme = useTheme();

  return (
    <Grid container columnSpacing={2} rowSpacing={2}>
      <Grid
        item
        md={3}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <FontAwesomeIcon
          icon={faFileInvoiceDollar}
          size="4x"
          color={theme.palette.common.gunmetalBlue}
        />
      </Grid>
      <Grid item md={9}>
        <StyledHeader>Pay</StyledHeader>
        <StyledParagraph>
          Your Cowbell Cyber Insurance Policy is ready, please make payment
        </StyledParagraph>
        <Link
          style={{ display: 'block' }}
          to={`/customer/policies/${policy.id}/pay/${useSelector(
            ({ account }) => account.paymentProcessor
          )}/${policy.product}`}
        >
          <SolidButton
            type="submit"
            sx={{ marginTop: '1rem', width: '100% !important' }}
          >
            Pay
          </SolidButton>
        </Link>
      </Grid>
    </Grid>
  );
};
